import { BaseLoaderProps } from "../types/types";

export const defaultProps: Required<BaseLoaderProps> = {
  size: 80,
  primaryColor: "#3B82F6",
  secondaryColor: "#93C5FD",
  speed: 2,
};
